<div
  class="countdown"
  [ngClass]="variantClass"
  [class.countdown-urgent]="isUrgent"
  [class.countdown-critical]="isCritical"
>
  {{ timeRemaining }}
</div>
